import map from 'lodash/map'
import React, { FC, useCallback } from 'react'

import { FacetDescriptionContent } from '@Components/Facet/FacetDescription/FacetDescriptionContent'
import { FacetDescriptionOverview } from '@Components/Facet/FacetDescription/FacetDescriptionOverview'
import { NativeModalBody, NativeModalHeader } from '@Components/Modal/NativeModal/NativeModal'
import { useFacetDescription } from '@Globals/CMS/useFacetDescriptions'

export interface FacetDescriptionModalProps {
  facetDescriptionIDs: string[]
}

const facetDescriptionIDKey = 'facet_description_'

export const FacetDescriptionModal: FC<FacetDescriptionModalProps> = ({ facetDescriptionIDs }) => {
  const pages = useFacetDescription({ openModal: true, pageIDs: facetDescriptionIDs })
  const scrollToIndex = useCallback((index: number) => {
    const target = document.getElementById(facetDescriptionIDKey + index)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])
  return (
    <>
      <NativeModalHeader />
      <NativeModalBody>
        {pages.length > 1 && (
          <FacetDescriptionOverview
            pages={pages}
            setIndex={scrollToIndex}
          />
        )}
        {map(pages, (page, index) => (page.blocks
                && <FacetDescriptionContent key={facetDescriptionIDKey + index} blocks={page.blocks} id={facetDescriptionIDKey + index} />))}
      </NativeModalBody>
    </>
  )
}
